import apiClient from '@/utils/request'
import { IGeneralResponse } from '@/api/types'

export interface IUserVerificationAttributes {
  id?: number
  account_type: string
  account: string
  first_name: string
  last_name: string
  country_code: string
  country_name?: string
  address: string
  company_name: string
  verify: boolean
  verified: boolean
  blocked: boolean
  status?: string
  message?: string
}

export interface IUserVerification {
  id: string
  type: 'userverification'
  attributes: IUserVerificationAttributes
}

export interface IUserVerificationResponse extends IGeneralResponse {
  data: IUserVerification
  url: string
  errors: Record<string, unknown>
}

export const finishItem = async (): Promise<IUserVerificationResponse> => {
  const response = await apiClient.post<IUserVerificationResponse>(
    '/user_verifications/finish'
  )
  return response.data
}
